import React from 'react';

import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper, { PaperProps } from "@mui/material/Paper";
import Draggable from "react-draggable";

function DraggablePaper(props: PaperProps) {
  return (
    <Draggable
      handle="#legend"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export const CatchmentMapLegend = () => {

  const theme = useTheme();

  return (
    <DraggablePaper
      id='legend'
      elevation={2}
      sx={{
        position: "fixed",
        bottom: 40,
        left: 16,
        width: '120px',
        p: 1,
        // background: 'transparent'
      }}
    >
      <Stack direction='column' spacing={1} justifyContent={'center'}>
        {/*<Typography variant='body1'>Legend</Typography>*/}
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Box height={10} width={10} bgcolor={'#8A77B4'} borderRadius={'2px'} mr={1}/>
          <Typography variant='body2'>Catchment</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Box height={10} width={10} bgcolor={'#82e1f2'} borderRadius={'2px'} mr={1}/>
          <Typography variant='body2'>Baseline</Typography>
        </Box>
      </Stack>
    </DraggablePaper>
  );
}
